var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 3.25C7.58591 3.25 7.25012 3.58579 7.25012 4C7.25012 4.41421 7.58591 4.75 8.00012 4.75H18.0001C18.6905 4.75 19.2501 5.30964 19.2501 6V18C19.2501 18.6904 18.6905 19.25 18.0001 19.25H8.00012C7.58591 19.25 7.25012 19.5858 7.25012 20C7.25012 20.4142 7.58591 20.75 8.00012 20.75H18.0001C19.5189 20.75 20.7501 19.5188 20.7501 18V6C20.7501 4.48122 19.5189 3.25 18.0001 3.25H8.00012Z",
    fill: "#00322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46967 16.5302C7.76256 16.8231 8.23744 16.8231 8.53033 16.5302C8.82322 16.2373 8.82322 15.7624 8.53033 15.4695L5.81066 12.7499H16C16.4142 12.7499 16.75 12.4141 16.75 11.9999C16.75 11.5857 16.4142 11.2499 16 11.2499H5.81066L8.53033 8.53021C8.82322 8.23732 8.82322 7.76244 8.53033 7.46955C8.23744 7.17665 7.76256 7.17665 7.46967 7.46955L3.46967 11.4695C3.17678 11.7624 3.17678 12.2373 3.46967 12.5302L7.46967 16.5302Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnLogout);
export default __webpack_public_path__ + "static/media/icn-logout.a21f5ec3b9dd5380b9aee57cedc2182b.svg";
export { ForwardRef as ReactComponent };